(ns kyber.components.composite.volume
  (:require [re-frame.core :as re-frame]

            [kyber.styles.core :refer [gs styles->classes]]
            [kyber.styles.constants :refer [volume-controls-min-height]]))

(def classes
  (styles->classes
   {:volume-bar-container
    {:display :flex
     :height "100%"
     :min-height (str volume-controls-min-height "px")
     :justify-content :space-between
     :align-items :flex-end
     :position :relative
     :cursor :pointer
     :padding [[(gs [:spacing :p0])
                (gs [:spacing :p8])
                (gs [:spacing :p0])
                (gs [:spacing :p8])]]

     (gs [:queries :mobile-landscape])
     {:display :none}

     (gs [:queries :ie])
     {:min-width (gs [:spacing :p20])
      :padding (gs [:spacing :p0])
      :margin-right (gs [:spacing :p8])}}

    :volume-bar
    {:width "2px"
     :background (gs [:colors :gray-scale-300])
     :margin-right "3px"
     "&:last-child" {:margin-right (gs [:spacing :p0])}}

    :volume-slider
    {"-webkit-appearance" :none
     :background (gs [:colors :primary-lite-400])
     :width "110px"
     :height "20px"
     :border (str (gs [:spacing :p8])
                  " solid "
                  (gs [:colors :primary-lite-600]))

     "&:focus"
     {:outline :none}

     "&::-ms-track"
     {:background :transparent
      :border-color :transparent
      :color :transparent}

     "&::-webkit-slider-thumb"
     {"-webkit-appearance" :none
      :width "12px"
      :height "12px"
      :border-radius "50%"
      :background-color (gs [:colors :true-white])}

     "::-moz-range-thumb"
     {:width "12px"
      :height "12px"
      :border-radius "50%"
      :background-color (gs [:colors :true-white])}

     "&::-ms-thumb"
     {:width "12px"
      :height "12px"
      :border-radius "50%"
      :background-color (gs [:colors :true-white])}

     (gs [:queries :ie])
     {:border-radius (gs [:radius :r7])
      :border (str "2px solid " (gs [:colors :primary-lite-600]))
      :padding (gs [:spacing :p0])
      :margin (gs [:spacing :p0])}}

    :volume-slider-container
    {:transform "rotate(-90deg)"
     :left "-40px"
     :bottom "60px"
     :height "25px"
     :position :absolute}}))

(defn render
  {:doc "Player controls (volume)"
   :id :volume-button
   :version 0
   :variant :a}
  [{:keys [volume show-volume-controls player-key]}]
  [:div {:on-click #(re-frame/dispatch
                     [:media-player/toggle-volume-controls
                      {:player-key player-key
                       :action (if show-volume-controls
                                 :close
                                 :open)}])
         :role "button"
         :tabIndex 0
         :aria-label "Volume"
         :class (:volume-bar-container classes)}

   [:div {:class (:volume-slider-container classes)
          :style {:display (if show-volume-controls
                             :block
                             :none)}}
    [:input {:type :range
             :min 0
             :max 100
             :default-value 100
             :aria-label "Volume level"
             :class (:volume-slider classes)
             :on-change #(re-frame/dispatch
                          [:media-player/adjust-volume
                           {:player-key player-key
                            :volume (-> %
                                        .-target
                                        .-value
                                        (/ 100))}])}]]

   [:div {:class (:volume-bar classes)
          :style (cond-> {:height "20%"}
                   (>= volume 0.10)
                   (assoc :background (gs [:colors :primary-lite-600])))}]
   [:div {:class (:volume-bar classes)
          :style (cond-> {:height "35%"}
                   (>= volume 0.20)
                   (assoc :background (gs [:colors :primary-lite-600])))}]
   [:div {:class (:volume-bar classes)
          :style (cond-> {:height "50%"}
                   (>= volume 0.40)
                   (assoc :background (gs [:colors :primary-lite-600])))}]
   [:div {:class (:volume-bar classes)
          :style (cond-> {:height "70%"}
                   (>= volume 0.70)
                   (assoc :background (gs [:colors :primary-lite-600])))}]
   [:div {:class (:volume-bar classes)
          :style (cond-> {:height "100%"}
                   (= volume 1)
                   (assoc :background (gs [:colors :primary-lite-600])))}]])
